import React, { Fragment } from "react";
import "./Cart.css";
import { Container, CssBaseline, Grid } from "@mui/material";
import StepperItems from "./../../components/Steppers/Items/Items";

const Cart = (props) => {
  const { location } = props;

  const steps = [
    location.search.includes("stagedOrder=1") ? "Staged Order" : "Cart",
    "Details",
  ];

  return (
    <Fragment>
      <CssBaseline />
      <Container maxWidth="lg" className="container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StepperItems {...props} steps={steps} />
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default Cart;
